<template>
    <div class="field__container" :class="{'field__container--no-label': !title || !labelFor, 'field__container--error': errorMessage, 'field__container--mandatory': required}">

        <slot name="label">
            <label
                    v-if="title"
                    :for="name"
                    class="label"
            >
                {{ title }}
            </label>
        </slot>

        <slot name="input">
            <input
                    type="radio"
                    v-for="(optionLabel, optionValue) in selectOptions"
                    v-model="model"
                    :name="name"
                    :value="optionValue"
                    :key="optionValue"
                    class="form__control"
            >
                {{ optionLabel }}
            </input>
        </slot>
    </div>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'

    export default {
        name: 'FieldRadio',
        mixins: [
            FieldMixin
        ],
        methods: {
            isChecked(option) {
                return _.inArray(option,this.value);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldRadio.vue